import GitInfo from 'react-git-info/macro'

const gitInfo = GitInfo()

let confProp
if (process.env.REACT_APP_TARGET === 'production') {
  confProp = {
    DEBUG: false,
    SERVER: {
      restBase: 'https://api.rework.so',
      restURL: 'https://api.rework.so/v1',
      URL: 'https://api.rework.so/graphql',
      wsURL: 'wss://api.rework.so:8002/graphql/',
    },
  }
} else if (process.env.REACT_APP_TARGET === 'test') {
  confProp = {
    DEBUG: false,
    SERVER: {
      restBase: 'https://dev.api.rework.so',
      restURL: 'https://dev.api.rework.so/v1',
      URL: 'https://dev.api.rework.so/graphql',
      wsURL: 'wss://dev.api.rework.so:8002/graphql/',
    },
  }
} else if (process.env.REACT_APP_TARGET === 'test1') {
  confProp = {
    DEBUG: false,
    SERVER: {
      restBase: 'http://chat-test.rework.so:8001',
      restURL: 'http://chat-test.rework.so:8001/v1',
      URL: 'http://chat-test.rework.so:8001/graphql',
      wsURL: 'ws://chat-test.rework.so:8002/graphql/',
    },
  }
} else if (process.env.REACT_APP_TARGET === 'log') {
  confProp = {
    DEBUG: false,
    SERVER: {
      restBase: 'http://192.168.50.100:8001',
      restURL: 'http://192.168.50.100:8001/v1',
      URL: 'http://192.168.50.100:8001/graphql',
      wsURL: 'ws://192.168.50.100:8002/graphql/',
    },
  }
} else {
  confProp = {
    DEBUG: true,
    SERVER: {
      restBase: 'http://localhost:8001',
      restURL: 'http://localhost:8001/v1',
      URL: 'http://localhost:8001/graphql',
      wsURL: 'ws://localhost:8002/graphql/',
    },
  }
}

confProp.defaultLocale = 'en-US' // 'ko-KR'

if (window.globalConfig != null) {
  if (window.globalConfig.restURL != null) {
    confProp.SERVER.restURL = window.globalConfig.restURL
  }
  if (window.globalConfig.URL != null) {
    confProp.SERVER.URL = window.globalConfig.URL
  }
  if (window.globalConfig.LOCALE != null) {
    confProp.defaultLocale = window.globalConfig.LOCALE
  }
}

confProp.gitInfo = gitInfo

const conf = confProp

export default conf
